import script from "./ComingSoon.vue?vue&type=script&setup=true&lang=js"
export * from "./ComingSoon.vue?vue&type=script&setup=true&lang=js"

import "./ComingSoon.vue?vue&type=style&index=0&id=1e6ec161&lang=css"

const __exports__ = script;

export default __exports__